module.exports = __webpack_public_path__ + "static/media/sheet-clmb.86065067.jpg";